import React, { Component } from 'react';
import { Link } from "react-router-dom";
export class Chapter8 extends Component {
  static displayName = Chapter8.name;

  render () {
    return (
      <div>
        <section id="jeevan-parichay" className="container" style={{ marginTop: "60px", marginBottom: "80px" }}>
        <div className="card" style={{ padding: "34px 36px" }}>
          {/* Main Heading */}
          <h2 style={{color: "var(--accent)",textAlign: "center",fontSize: "clamp(26px,3vw,38px)",marginBottom: "18px",}}>
            🌼 अध्याय—8: श्मशान की तपोभूमि और माँ बगलामुखी की कृपा 🌼
          </h2>

          {/* Intro */}
          <div style={{display: "flex",gap: "24px",alignItems: "center",flexWrap: "wrap",marginBottom: "18px",}}>
            {/* Image */}
            <div style={{ flex: "0 0 220px", textAlign: "center" }}>
              <div style={{width: "200px", height: "200px", borderRadius: "50%", overflow: "hidden", margin: "0 auto",border: "4px solid var(--accent)",boxShadow: "0 20px 60px rgba(0,0,0,0.6)"}}>
                <img src="/images/IMG_5427-removebg-preview.png" alt="Swami Brahmanand Saraswati Ji" style={{ width: "100%", height: "100%", objectFit: "cover" }}/>
              </div>
              <div style={{ marginTop: "10px", color: "var(--muted)", fontSize: "13px" }}>
                पूज्य स्वामी ब्रह्मानंद सरस्वती जी
              </div>
            </div>

            {/* Intro Text */}
            <div style={{ flex: 1, minWidth: "260px" }}>
              <p style={{ margin: 0, color: "rgba(255,235,200,0.95)", lineHeight: 1.8 }}>
                श्री स्वामी ब्रह्मानंद सरस्वती जी का जीवन साधारण संतों जैसा कभी नहीं रहा। उन्होंने जहाँ भी साधना की—वन, पर्वत, नदी, गुफा—हर स्थान उनके तप से पवित्र हो उठा। परंतु उनके जीवन का एक अध्याय ऐसा है जिसे सुनकर आज भी साधक विस्मय और श्रद्धा से भर उठते हैं—
              </p>
            </div>
          </div>

          <hr style={{border: "none", height: "1px", background: "rgba(255,255,255,0.03)", margin: "18px 0 22px",}}/>

          {/* Narrative */}
          <div style={{ marginTop: "22px" }}>
            <h3 style={{ color: "var(--accent)", marginBottom: "8px" }}>श्मशान में की गई उनकी कठोर तपस्या।</h3>
            
            <h4 style={{ color: "#3fdd05", marginBottom: "8px" }}>1. श्मशान: जहाँ संसार समाप्त होता है, वहाँ उनकी साधना प्रारंभ हुई</h4>
            <p style={{ color: "var(--muted)", lineHeight: 1.86, textAlign: "justify" }}>
              रात का समय, गहन निस्तब्धता, दूर-दूर तक फैली हुई राख, बुझी चिताओं की गंध, और हवाओं में गर्दन तक चढ़ी वीरानगी। जहाँ संसार जाने से डरता है, जहाँ मनुष्य अपनी सबसे अंतिम यात्रा के बाद पहुँचता है, वहाँ स्वामी जी ने वर्षों तक साधना की। कोई साहस नहीं कर सकता था उस क्षेत्र में रात बिताने का। पर वे वहीं ध्यानस्थ हो जाते थे—निरभय, अचल, अडिग। उनकी साधना का लक्ष्य केवल सिद्धि नहीं था, बल्कि अहंकार का पूर्ण विसर्जन, और माया के भय पर विजय प्राप्त करना। श्मशान में रात-रात भर ध्यान करते हुए वे कहते थे— “अंत को पहचानो, तभी आरंभ का ज्ञान होगा।”
            </p>

            <h4 style={{ color: "#3fdd05", marginBottom: "8px" }}>2. माँ बगलामुखी की आराधना</h4>
            <p style={{ color: "var(--muted)", lineHeight: 1.86, textAlign: "justify" }}>
              श्मशान साधना का केंद्र था उनकी माँ बगलामुखी के प्रति अद्वितीय भक्ति। वे माँ को शक्ति की साक्षात् मूर्ति, विजय की स्वरूपिणी, और भय को भस्म करने वाली महामाया रूप में मानते थे। रात्रि के मध्य वे पीले अथवा भगवा वस्त्र धारण करके माँ बगलामुखी के मंत्रों का जाप करते थे— “ॐ ह्लीं बगलामुखि सर्वदुष्टानां वाचं मुखं पदं स्तंभय ह्लीं ॐ नमः।” कहते हैं, उनकी साधना इतनी प्रभावशाली थी कि चारों ओर की नकारात्मक शक्तियाँ स्वयं शांत हो जाती थीं, मानो किसी ने उन्हें बाँध दिया हो। श्मशान की काली रातें उनकी साधना से सोने जैसी उज्ज्वल हो उठती थीं।
            </p>

            <h4 style={{ color: "#3fdd05", marginBottom: "8px" }}>3. अग्नि, राख और निर्विकल्प समाधि</h4>
            <p style={{ color: "var(--muted)", lineHeight: 1.86, textAlign: "justify" }}>
              कई बार वे चिताओं की बुझी राख पर बैठकर समाधि में लीन हो जाते। बाहर का भय उनकी भीतरी शांति के आगे तुच्छ लगता था। घंटों तक वे एक मुद्रा में स्थिर बैठे रहते— न कोई हलचल, न कोई विचार, बस पूर्ण समाधि। उनके शिष्यों ने कहा है कि कई बार ऐसा प्रतीत होता था मानो वे वहाँ बैठकर प्रकृति की शक्तियों को नियंत्रित कर रहे हों, पर वास्तव में वे केवल अपने भीतर की शक्ति को जागृत कर रहे थे।
            </p>

            <h4 style={{ color: "#3fdd05", marginBottom: "8px" }}>4. भय से परे—पूर्ण निर्भयता का स्वरूप</h4>
            <p style={{ color: "var(--muted)", lineHeight: 1.86, textAlign: "justify" }}>
              स्वामी जी के जीवन का यह काल इस बात का साक्षी है कि सच्चा साधक केवल वह है जो अपने भीतर के भय को जड़ से नष्ट कर दे।
              <br/><br/>
              श्मशान जैसी जगह में साधना करने का अर्थ था—<br/>
              ✔ मृत्यु को प्रत्यक्ष स्वीकार करना<br/>
              ✔ अहंकार के अंतिम कण को भी त्याग देना<br/>
              ✔ मन के सभी विकारों पर पूर्ण नियंत्रण<br/>
              ✔ देवियों की कृपा को साधना में अवतरण देना<br/>
              और यही कारण था कि उनकी वाणी में अपार शक्ति, उनके दर्शन में दिव्य तेज, और उनके संकल्प में अटूट सामर्थ्य था।
            </p>

            <h4 style={{ color: "#3fdd05", marginBottom: "8px" }}>5. माँ बगलामुखी का दिव्य अनुभव</h4>
            <p style={{ color: "var(--muted)", lineHeight: 1.86, textAlign: "justify" }}>
              उनकी साधना के दौरान अनेक बार ऐसा हुआ कि वे माँ बगलामुखी की आन्तरिक अनुभूति में डूब गए। 
              कई बार वे बताते— “साधक जब अपने भीतर दिव्य प्रकाश को अनुभव करने लगता है, तो देवियाँ स्वयं उसकी रक्षा करती हैं।”
              
              शिष्यों ने कई बार अनुभव किया कि श्मशान की नकारात्मक ऊर्जा स्वामी जी के समीप आते ही शांत, स्थिर और मधुर हो जाती थी— मानो स्वयं माँ बगलामुखी उनका रक्षण कर रही हों।
            </p>

            <h3 style={{ color: "var(--accent)", marginBottom: "8px" }}>अध्याय का सार</h3>
            <p style={{ color: "var(--muted)", lineHeight: 1.86, textAlign: "justify" }}>
              श्मशान की तपस्या ने उन्हें अद्भुत आध्यात्मिक शक्ति, अटूट आत्मविश्वास, और माँ बगलामुखी की गहन कृपा से परिपूर्ण कर दिया। यही वह अध्याय था जिसने उन्हें “योगियों में अग्रगण्य”, और “शक्ति-साधना के महान आचार्य” बना दिया।
            </p>
          </div>

          {/* CTA */}
          <div style={{ textAlign: "center", marginTop: "26px" }}>
            <Link to="/Chapter7" className="btn" style={{ display: "inline-block" }}>पिछला अध्याय</Link>-
            <Link to="/Chapter9" className="btn" style={{ display: "inline-block" }}>अगला अध्याय</Link>
          </div>
        </div>
      </section>
      </div>
    );
  }
}